<template>
    <div class="container-fluid">
        <br>
        <router-link to="/devices" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{$t('words.cancel') }}
        </router-link>
        <br>
        <br>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">
                        <li role="presentation" class="nav-item">
                            <a class="nav-link active" href="#tabFormulario" aria-controls="tabFormulario" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-chat"></i>
                                Chats
                            </a>
                        </li>
                        <li role="presentation" class="nav-item">
                            <a class="nav-link" href="#tabMessages" aria-controls="tabMessages" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-file-text"></i>
                                Mensagens
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                        <div class="tab-pane active" id="tabFormulario">
                            <button class="btn btn-default" @click="getMessages()">Puxar conversas</button>
                            chats..
                            <table class="table table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th>id</th>
                                        <th>detalhes</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in response" :key="i">
                                        <td><button class="btn btn-default" @click="getMesageById(item.id)">{{item.id}}</button></td>
                                        <td>{{item}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                         <div class="tab-pane" id="tabMessages">
                           <table class="table table-hover table-condensed">
                                <thead>
                                    <tr>
                                        <th>Usuario</th>
                                        <th>Mensagem</th>
                                        <th>Data</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in messages" :key="i">
                                        <td><span v-if="item.key.fromMe">Eu</span><span v-else>{{item.key.remoteJid}}</span></td>
                                        <td>{{item.message.conversation || item.message.extendedTextMessage || item}}</td>
                                        <td>{{new Date(item.messageTimestamp * 1000)}}</td>
                                    </tr>
                                </tbody>
                            </table>
                         </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                loading: false,
                response: [],
                messages: [],
            };
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
        methods: {
            getMessages() {
                this.$store
                    .dispatch('getDeviceMessages', this.$route.params.id)
                    .then(response => {
                        console.log(response);
                        this.response = response;
                    }).catch(error => {
                        console.log(error);
                        toastr({
                            title: error.message,
                            icon: error.status
                        });
                    });
            },
            getMesageById(id) {
                this.$store
                    .dispatch('getChatMessages', {device: this.$route.params.id, chatId: id})
                    .then(response => {
                        console.log(response);
                        this.messages = response.data;
                        $('[href="#tabMessages"]').tab('show');
                    }).catch(error => {
                        console.log(error);
                        toastr({
                            title: error.message,
                            icon: error.status
                        });
                    });
            },
        },

    };
</script>